export default "__VITE_PUBLIC_ASSET__4c414a03__"